<template>
  <div class="profil">
        <!-- main-area -->
        <main class="fix">
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="bg-img position-absolute top-0 start-0 w-100 h-100" data-background="assets/img/bg/breadcrumb_bg.jpg"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">Kontak Kami</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><router-link to="/">Beranda</router-link></li>
                                        <li class="breadcrumb-item active" aria-current="page">Kontak Kami</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <!-- breadcrumb-area-end -->
            <section class="contact__area">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="contact-map">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3978.4182777216633!2d122.27868667497708!3d-4.332292495641737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2da28169975cfe0d%3A0x76454e8b1b597acc!2sKantor%20Bupati%20Kabupaten%20Konawe%20Selatan!5e0!3m2!1sid!2sid!4v1753193146277!5m2!1sid!2sid" allowfullscreen="" loading="lazy"></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="contact__content">
                                <div class="section-title mb-35">
                                    <h2 class="title">Kontak Kami</h2>
                                </div>
                                <div class="contact__info">
                                    <ul class="list-wrap">
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-pin"></i>
                                            </div>
                                            <div class="content">
                                                <h4 class="title">Alamat</h4>
                                                <p>Jl. Poros Andoolo No.1, Potoro, Kec. Andoolo, Kabupaten Konawe Selatan, Sulawesi Tenggara 93819</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-phone-call"></i>
                                            </div>
                                            <div class="content">
                                                <h4 class="title">Telepon</h4>
                                                <a href="tel:082148094847">+62 821 4809 4847</a>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-mail"></i>
                                            </div>
                                            <div class="content">
                                                <h4 class="title">E-mail</h4>
                                                <a href="mailto:diskominfo@konaweselatankab.go.id">diskominfo@konaweselatankab.go.id</a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <div class="contact__form-wrap">
                                <h2 class="title pb-2">Kirim Pesan Kepada Kami</h2>
                                <form  @submit.prevent="addData()">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-grp">
                                                <input type="text" v-model="form.nama" placeholder="Nama" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-grp">
                                                <input type="text" v-model="form.email" placeholder="Email" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-grp">
                                        <input type="text" v-model="form.subjek" placeholder="Subjek" />
                                    </div>
                                    <div class="form-grp">
                                        <textarea v-model="form.pesan" placeholder="Pesan"></textarea>
                                    </div>
                                    <button type="submit" class="btn">Kirim Pesan</button>
                                </form>
                                <p class="ajax-response mb-0"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- contact-area-end -->
        </main>
        <!-- main-area-end -->
  </div>
</template>

<script>

export default {
  name: 'Profil',

  data () {
    return {
        file_path: this.$store.state.url.URL_APP + "uploads/",
        unit_kerja: this.$store.state.UNIT_KERJA,
        form : {
            id : '',
            nama : '',
            email : '',
            subjek : '',
            pesan : '',
            unit_kerja : 'Rakyat',
            status : '0',
            keterangan : 'NULL',
        },
    }
  },

  methods: {
    // onFileSelected: function(event) {
    //   this.form.foto = event.target.files[0];
    // },
    addData: function() {
        // console.log('====================================');
        // console.log(this.$store.state.url.URL_LAYANAN);
        // console.log('====================================');
        var formData = new FormData();

        formData.append("nama", this.form.nama);
          formData.append("email", this.form.email);
          formData.append("subjek", this.form.subjek);
          formData.append("pesan", this.form.pesan);
          formData.append("unit_kerja", this.form.unit_kerja);

        fetch(this.$store.state.url.URL_KONTAK + "addData", {
            method: "POST",
            body: formData
        }).then(res_data => {
            console.log(res_data);
            
            alert("Berhasil Mengirim Pesan");
        });
    },
  },
}
</script>
